import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Box,
  HStack,
  FormControl,
  FormLabel,
  Select,
  Text,
  Center
} from "@chakra-ui/react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import CoreService from "../../services/CoreService";
import SchemaDetailCard from "./Components/SchemaDetailCard";

export default class SchemaManagementPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgConfig: null,
      schemaId: null,
      schemaJson: null,
      isLoading: true
    };

    this.coreService = new CoreService();

    this.updateSchema = this.updateSchema.bind(this);
  }

  async componentDidMount() {
    var orgConfigResult = await this.coreService.fetchOrgConfiguration(this.props.userSession.gcid, this.props.userSession.token);
    if (orgConfigResult.hasError) {
      this.props.onErrorPageRequest("Error fetching Org Configuration.");
      return;
    }
    let schemaId = orgConfigResult.dataResult.SchemaList[0];
    var schemaResult = await this.coreService.fetchSchema(schemaId, this.props.userSession.gcid, this.props.userSession.token);
    if (schemaResult.hasError) {
      this.props.onErrorPageRequest("Error fetching Schema.");
      return;
    }
    this.setState({
      orgConfig: orgConfigResult.dataResult,
      schemaId: schemaId,
      schemaJson: schemaResult.dataResult,
    });
  }

  async updateSchema(ev) {
    var schemaId = ev.target.value;
    var schemaResult = await this.coreService.fetchSchema(schemaId, this.props.userSession.gcid, this.props.userSession.token);
    if (schemaResult.hasError) {
      this.props.onErrorPageRequest("Error fetching Schema.");
      return;
    }
    this.setState({
      schemaId: schemaId,
      schemaJson: schemaResult.dataResult,
    });
  }

  render() {
    const loadingIcon = this.state.isLoading ? (
      <FontAwesomeIcon icon="sync-alt" color="green" spin />
    ) : (
      ""
    );

    return (
      (this.state.orgConfig && this.state.schemaId) ?
        <div className='main'>
          <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>

            <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>Observation Schema Viewer</Text>
            <Center marginTop='3vw'>
              <Select
                // placeholder="schema"
                type="dropdown"
                autoComplete="on"
                value={this.state.schemaId}
                name="schemaId"
                id="schemaId"
                onChange={(ev) => this.updateSchema(ev)}
                bg='white'
                w='30vw'
              >
                {this.state.orgConfig.SchemaList.map((sch) => (
                  <option key={sch}>{sch}</option>
                ))}
              </Select>
            </Center>

            {(this.state.schemaJson) ?

              <Box>
                <SchemaDetailCard
                  userSession={this.props.userSession}
                  schemaJson={this.state.schemaJson}
                />
              </Box>

              : <span />}

          </Box>
        </div>
        : <span />
    );
  }
}
